var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "right_svg__Thumbnail_Product right_svg__page_Image right_svg__Position_Right right_svg__Side"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#80B1FF",
    d: "M56 47H38a2 2 0 01-2-2V27a2 2 0 012-2h18a2 2 0 012 2v18a2 2 0 01-2 2",
    className: "right_svg__illus-clr-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6E6FF",
    d: "M43.477 34.463l1.968 1.975 2.835-3.563a1 1 0 011.489-.085l5.518 5.502c.63.63.186 1.708-.706 1.708H39.269c-.87 0-1.325-1.032-.74-1.675l3.5-3.831a1 1 0 011.448-.031",
    className: "right_svg__illus-clr-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3885FF",
    d: "M30 41v2H14v-2h16zm0-6v2H14v-2h16zm-8-6v2h-8v-2h8z",
    className: "right_svg__illus-clr-2"
  }))));
}

export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='72' height='72' fill='none' viewBox='0 0 72 72'%3e %3cg class='Thumbnail_Product page_Image Position_Right Side'%3e %3cpath fill='%2380B1FF' d='M56 47H38a2 2 0 01-2-2V27a2 2 0 012-2h18a2 2 0 012 2v18a2 2 0 01-2 2' class='illus-clr-1'/%3e %3cpath fill='%23D6E6FF' d='M43.477 34.463l1.968 1.975 2.835-3.563a1 1 0 011.489-.085l5.518 5.502c.63.63.186 1.708-.706 1.708H39.269c-.87 0-1.325-1.032-.74-1.675l3.5-3.831a1 1 0 011.448-.031' class='illus-clr-3'/%3e %3cpath fill='%233885FF' d='M30 41v2H14v-2h16zm0-6v2H14v-2h16zm-8-6v2h-8v-2h8z' class='illus-clr-2'/%3e %3c/g%3e %3c/svg%3e";
export { SvgRight as ReactComponent };